import { render } from "./HelpDialogWorkflowCards.vue?vue&type=template&id=3ed310f2"
import script from "./HelpDialogWorkflowCards.vue?vue&type=script&lang=js"
export * from "./HelpDialogWorkflowCards.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__